import { Box } from "@chakra-ui/react";
import {
  getCdnImageSrc,
  Image,
  VStack,
  responsive,
  colors,
  HStack,
  ColorIcon,
} from "goi_common";
import SlideBase from "react-slick";
import styled from "@emotion/styled";

export default function NowRequestSection() {
  return (
    <VStack width="100%" alignItems="center" background={colors.gray900}>
      <VStack
        maxWidth={`${1200}px`}
        gap="28px"
        css={responsive({
          padding: {
            base: "64px 0px",
            lg: "120px 24px",
          },
        })}
      >
        <VStack
          width="100%"
          gap="16px"
          css={responsive({ alignItems: { base: "center", lg: "flex-start" } })}
        >
          <Box className="white head_28_b lg_head_42_b" textAlign="center">
            아직도 퇴근하고 <br className="lg_over_hidden" />
            근조화환 보내느라 고생하세요?
          </Box>
          <Box
            className="gray300 subtitle_16_m lg_head_24_r"
            textAlign="center"
          >
            다른 인사담당자들은 근조화환 3초면 보내고 있습니다.
            <br className="lg_over_hidden" /> 담당자님의 시간은 소중하니까요.{" "}
          </Box>
          <Box
            className="gray300 body_16_r"
            marginTop="20px"
            textAlign="center"
          >
            *개인정보보호를 위해 <br className="lg_over_hidden" /> 이미지는
            모자이크 처리 되었습니다.
          </Box>

          <Box
            padding="20px"
            css={responsive({
              width: { base: "100vw", lg: "1000px" },
              height: "auto",
            })}
          >
            <Slide
              initialSlide={0}
              arrows={false}
              centerMode={true}
              infinite={true}
              variableWidth={true}
              autoplay={true}
              speed={1000}
            >
              <VStack width="300px" gap="16px">
                <Image
                  src={getCdnImageSrc(`b2b/flower/f-ex-1.png`)}
                  width="100%"
                  height="auto"
                  alt=""
                  css={{ borderRadius: "10px" }}
                />
                <HStack gap="10px">
                  <ColorIcon
                    name="icon-pin-location-mono"
                    size={20}
                    color={colors.orange700}
                  />
                  <Box className="gray200 subtitle_18_r">
                    서울 관악구 / 1시간 전
                  </Box>
                </HStack>
              </VStack>
              <VStack width="300px" gap="16px">
                <Image
                  src={getCdnImageSrc(`b2b/flower/f-ex-2.png`)}
                  width="100%"
                  height="auto"
                  alt=""
                  css={{ borderRadius: "10px" }}
                />
                <HStack gap="10px">
                  <ColorIcon
                    name="icon-pin-location-mono"
                    size={20}
                    color={colors.orange700}
                  />
                  <Box className="gray200 subtitle_18_r">
                    서울 동대문구 / 1시간 전
                  </Box>
                </HStack>
              </VStack>
              <VStack width="300px" gap="16px">
                <Image
                  src={getCdnImageSrc(`b2b/flower/f-ex-3.png`)}
                  width="100%"
                  height="auto"
                  alt=""
                  css={{ borderRadius: "10px" }}
                />
                <HStack gap="10px">
                  <ColorIcon
                    name="icon-pin-location-mono"
                    size={20}
                    color={colors.orange700}
                  />
                  <Box className="gray200 subtitle_18_r">
                    강원 인제군 / 2시간 전
                  </Box>
                </HStack>
              </VStack>
              <VStack width="300px" gap="16px">
                <Image
                  src={getCdnImageSrc(`b2b/flower/f-ex-4.png`)}
                  width="100%"
                  height="auto"
                  alt=""
                  css={{ borderRadius: "10px" }}
                />
                <HStack gap="10px">
                  <ColorIcon
                    name="icon-pin-location-mono"
                    size={20}
                    color={colors.orange700}
                  />
                  <Box className="gray200 subtitle_18_r">
                    경기 성남시 / 2시간 전
                  </Box>
                </HStack>
              </VStack>
              <VStack width="300px" gap="16px">
                <Image
                  src={getCdnImageSrc(`b2b/flower/f-ex-5.png`)}
                  width="100%"
                  height="auto"
                  alt=""
                  css={{ borderRadius: "10px" }}
                />
                <HStack gap="10px">
                  <ColorIcon
                    name="icon-pin-location-mono"
                    size={20}
                    color={colors.orange700}
                  />
                  <Box className="gray200 subtitle_18_r">
                    대구 남구 / 2시간 전
                  </Box>
                </HStack>
              </VStack>
              <VStack width="300px" gap="16px">
                <Image
                  src={getCdnImageSrc(`b2b/flower/f-ex-6.png`)}
                  width="100%"
                  height="auto"
                  alt=""
                  css={{ borderRadius: "10px" }}
                />
                <HStack gap="10px">
                  <ColorIcon
                    name="icon-pin-location-mono"
                    size={20}
                    color={colors.orange700}
                  />
                  <Box className="gray200 subtitle_18_r">
                    전남 구례군 / 3시간 전
                  </Box>
                </HStack>
              </VStack>
              <VStack width="300px" gap="16px">
                <Image
                  src={getCdnImageSrc(`b2b/flower/f-ex-7.png`)}
                  width="100%"
                  height="auto"
                  alt=""
                  css={{ borderRadius: "10px" }}
                />
                <HStack gap="10px">
                  <ColorIcon
                    name="icon-pin-location-mono"
                    size={20}
                    color={colors.orange700}
                  />
                  <Box className="gray200 subtitle_18_r">
                    서울 마포구 / 3시간 전
                  </Box>
                </HStack>
              </VStack>
              <VStack width="300px" gap="16px">
                <Image
                  src={getCdnImageSrc(`b2b/flower/f-ex-8.png`)}
                  width="100%"
                  height="auto"
                  alt=""
                  css={{ borderRadius: "10px" }}
                />
                <HStack gap="10px">
                  <ColorIcon
                    name="icon-pin-location-mono"
                    size={20}
                    color={colors.orange700}
                  />
                  <Box className="gray200 subtitle_18_r">
                    경남 창원시 / 4시간 전
                  </Box>
                </HStack>
              </VStack>
              <VStack width="300px" gap="16px">
                <Image
                  src={getCdnImageSrc(`b2b/flower/f-ex-9.png`)}
                  width="100%"
                  height="auto"
                  alt=""
                  css={{ borderRadius: "10px" }}
                />
                <HStack gap="10px">
                  <ColorIcon
                    name="icon-pin-location-mono"
                    size={20}
                    color={colors.orange700}
                  />
                  <Box className="gray200 subtitle_18_r">
                    제주 제주시 / 4시간 전
                  </Box>
                </HStack>
              </VStack>
              <VStack width="300px" gap="16px">
                <Image
                  src={getCdnImageSrc(`b2b/flower/f-ex-10.png`)}
                  width="100%"
                  height="auto"
                  alt=""
                  css={{ borderRadius: "10px" }}
                />
                <HStack gap="10px">
                  <ColorIcon
                    name="icon-pin-location-mono"
                    size={20}
                    color={colors.orange700}
                  />
                  <Box className="gray200 subtitle_18_r">
                    충북 괴산군 / 5시간 전
                  </Box>
                </HStack>
              </VStack>
            </Slide>
          </Box>
        </VStack>
      </VStack>
    </VStack>
  );
}

const Slide = styled(SlideBase)`
  padding: 10px 0px;
  .slick-track {
    display: flex !important;
  }
  .slick-slide {
    padding: 0 8px;
  }
  .slick-list {
    margin: 0 -8px;
  }
`;
